<template>
  <tr>
    <th
      v-if="selectedTab !== 6 && selectedTab !== 7"
      class="py-4 px-6 bg-gray-100"
    ></th>
    <th
      v-for="(header, index) in currentTab.headers"
      :key="index"
      class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 hover:text-blue-500 cursor-pointer"
      @click="sortColumn(header.field.name)"
    >
      {{ header.title }}
      <i
        v-if="sortField === header.field.name"
        class="ml-2 fas"
        :class="sortDirection === 'desc' ? 'fa-sort-down' : 'fa-sort-up'"
      ></i>
    </th>
    <th
      v-if="currentTabHasOptions"
      class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900"
    >
      #
    </th>
  </tr>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  computed: {
    ...mapState(["selectedTab", "sortField", "sortDirection"]),
    ...mapGetters(["currentTab", "currentTabHasOptions"]),
  },
  methods: {
    ...mapActions(["sortColumn"]),
  },
};
</script>
